// extracted by mini-css-extract-plugin
export default {"select":"CustomSelect_select__uVYVo","select__options":"CustomSelect_select__options__lWSdK","open":"CustomSelect_open__n0AgE","select__option":"CustomSelect_select__option__Cnq8g"};